module.exports = __webpack_public_path__ + "static/media/created-on-ethereum.79d6af6f.webp";